<template>
  <div>
  	<div class="br-pagetitle d-flex justify-content-between align-items-center">
      <div class="d-flex align-items-center">
        <i class="fa fa-sitemap"></i>
        <div class="mg-l-20 mg-b-0 d-flex align-items-center">
          <h4 class=" mg-r-15">{{$t("transfer.快递签收入库")}}</h4>
          <div class="mode-change">
            <a href="javascript:;" class="btn btn-icon mg-r-5 btn-info"
              data-trigger="hover"
          	  data-toggle="tooltip-primary"
              data-placement="bottom"
              :data-original-title="$t('transfer.设置打印条形码尺寸')"
              @click="openSize()"
            >
              <div>
          		  <i class="icon ion-gear-b" style="font-size: 24px;"></i>
          	  </div>
            </a>
          </div>
        </div>
      </div>
      <div class="tx-right">
      </div>
    </div>
    <div class="d-flex align-items-center justify-content-start pd-x-20 pd-sm-x-30">
    	<div class="clear-key">
	        <a v-show="track_number" href="javascript:;" class=" mg-r-15" @click="clearKey('trackNumber')">
	          {{$t("transfer.包裹单号：")}}
	          <span class="mg-r-10">{{track_number}}</span>
	          <i class="fa fa-close"></i>
	        </a>
	        <a v-show="time_from || time_to" href="javascript:;" class=" mg-r-15" @click="clearKey('time')">
	          {{$t("transfer.扫描时间：")}}
	          <span class="mg-r-10">{{time_from}} ~ {{time_to}}</span>
	          <i class="fa fa-close"></i>
	        </a>
	        <a v-show="package_id" href="javascript:;" class=" mg-r-15" @click="clearKey('packageId')">
	          {{$t("transfer.内部ID：")}}
	          <span class="mg-r-10">{{package_id}}</span>
	          <i class="fa fa-close"></i>
	        </a>
	      </div>
    </div>  
  </div>  
</template>

<script>
export default {
  props: ['track_number','time_from','time_to','package_id'],
  data(){
    return {
    }
  },        
  methods: {
  	clearKey(type){
      this.$emit('clearKey', type)
    },
    openSize(){
      this.$emit('openSize')
    },
  }
}
</script>

<style lang="less" scoped>
.br-pagetitle .fa {
    font-size: 60px;
    line-height: 70px;
    color: #343a40;
}
.br-pagetitle i.fa{
  color: #17A2B8;
  font-size: 70px;
}
.show-white-style .br-pagetitle i.fa {
    color: #343a40;
}
.white-body .mode-change a.active .icon, .white-body .mode-change a:hover .icon{
    color: #fff;
}
.mode-change .btn-info,.mode-change .btn-info.active{
	color: #fff;
  background-color: #17a2b8;
  border-color: #17a2b8;
}
.mode-change .btn-info i,.mode-change .btn-info.active i{
	color: #fff;
}
</style>

